export default __webpack_public_path__ + "static/media/2.cdd27595.jpg";